module.exports = __webpack_public_path__ + "img/quote.a8c81a93.svg";